import React, { FC } from 'react'

import styled from 'styled-components'

import { LabelForGenreOrLanguage } from 'src/Components/LabelForGenreOrLanguage'

type Props = {
  selectedLanguage: string[]
  onClick: (language: string) => void
}

const Container = styled.div`
  display: flex;
  gap: 8px;
`

const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: stretch;
`

export const Selected: FC<Props> = (props) => {
  const { selectedLanguage, onClick } = props

  if (!selectedLanguage.length) {
    return null
  }

  return (
    <Wrapper>
      <Title>Selected</Title>
      <Container>
        {selectedLanguage.map((lang) => (
          <LabelForGenreOrLanguage
            key={lang}
            title={lang}
            onClick={() => onClick(lang)}
            hasCross
          />
        ))}
      </Container>
    </Wrapper>
  )
}
